export default __webpack_public_path__ + "fcd7e0a829ef253f751afbaeff4b6c46.svg";